import React from 'react';
import '../template-file-css/document-file-template.css';


export const GFIT_AuthorizationConsent = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GFIT_AuthorizationConsent' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <b><center>PART A - To be completed by Physician prescribing the medication (PLEASE WRITE CLEARLY) </center></b></p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Name of Physician</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Physician Contact Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPhysician' name='txtPhysician' className='add-only' /></td>
                        <td className='w-375'> <input type='text' id='txtContact' name='txtContact' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Physician Email</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEmail' name='txtEmail' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name of the Child</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Child's Date of Birth </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtNameoftheChild' name='txtNameoftheChild' className='add-only' /></td>
                        <td className='w-375'> <input type='date' id='txtDateofBirth' name='txtDateofBirth' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Reason for Request:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbReasonforRequest_1' name='cbReasonforRequest_1' className='add-only' value='Continue Current Medication Only' /> Continue Current Medication Only </td>
                        <td className='w-250'><input type='checkbox' id='cbReasonforRequest_2' name='cbReasonforRequest_2' className='add-only' value='Notification of Emergency Use' /> Notification of Emergency Use </td>
                        <td className='w-250'><input type='checkbox' id='cbReasonforRequest_3' name='cbReasonforRequest_3' className='add-only' value='New Medication' /> New Medication </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbReasonforRequest_3' name='cbReasonforRequest_3' className='add-only' value='Other' />Other </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_1' name='txtOther_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Allergies/Adverse Reactions:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbAllergies' name='cbAllergies' className='add-only' value=' NKDA' />  NKDA </td>
                    </tr>
                </table>

                <p className='w-750'> <b> <center>DSM V Diagnoses:</center> </b></p>

                <p className='w-750'>
                    <span className='eleHeader'>Axis I</span>
                    <textarea id='txtAxis_1' name='txtAxis_1' className='add-only'></textarea>

                    <span className='eleHeader'>Axis II</span>
                    <textarea id='txtAxis_2' name='txtAxis_2' className='add-only'></textarea>

                    <span className='eleHeader'>Axis III</span>
                    <textarea id='txtAxis_3' name='txtAxis_3' className='add-only'></textarea>

                    <span className='eleHeader'>Current psychotropic Medications, including PRN and Medications including dose, schedule and route:</span>
                    <textarea id='txtpsychotropicMedications' name='txtpsychotropicMedications' className='add-only'></textarea>

                    <span className='eleHeader'>Current Non-Psychotropic Medications, including nutritional supplements.</span>
                    <textarea id='txtNonPsychotropicMedications' name='txtNonPsychotropicMedications' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Was the child given unauthorized medications due to an emergency?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='radio' id='rbemergency_Yes' name='rbemergency' className='add-only' value='Yes' /> Yes &nbsp; </td>
                        <td className='w-150'><input type='radio' id='rbemergency_No' name='rbemergency' className='add-only' value='No' /> No &nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> If yes, please explain the situation below and list all medications given to the child, as well all other interventions that were attempted.</span>
                    <textarea id='txtallmedications' name='txtallmedications' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>1. RECOMMENDED MEDICATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMEDICATION_1' name='txtMEDICATION_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>DOSAGE</span> </td>
                        <td className='w-150'> <span className='eleHeader'> ROUTE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>RANGE OF DOSAGE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>TARGETED SYMPTOMS</span> </td>
                        <td className='w-150'> <span className='eleHeader'>DURATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtDOSAGE_1' name='txtDOSAGE_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtROUTE_1' name='txtROUTE_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtRANGE_1' name='txtRANGE_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtTARGETED_1' name='txtTARGETED_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDURATION_1' name='txtDURATION_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>2. RECOMMENDED MEDICATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMEDICATION_2' name='txtMEDICATION_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>DOSAGE</span> </td>
                        <td className='w-150'> <span className='eleHeader'> ROUTE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>RANGE OF DOSAGE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>TARGETED SYMPTOMS</span> </td>
                        <td className='w-150'> <span className='eleHeader'>DURATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtDOSAGE_2' name='txtDOSAGE_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtROUTE_2' name='txtROUTE_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtRANGE_2' name='txtRANGE_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtTARGETED_2' name='txtTARGETED_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDURATION_2' name='txtDURATION_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>3. RECOMMENDED MEDICATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMEDICATION_3' name='txtMtxtMEDICATION_3EDICATION_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>DOSAGE</span> </td>
                        <td className='w-150'> <span className='eleHeader'> ROUTE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>RANGE OF DOSAGE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>TARGETED SYMPTOMS</span> </td>
                        <td className='w-150'> <span className='eleHeader'>DURATION</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='txtDOSAGE_3' name='txtDOSAGE_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtROUTE_3' name='txtROUTE_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtRANGE_3' name='txtRANGE_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtTARGETED_3' name='txtTARGETED_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDURATION_3' name='txtDURATION_3' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Please attach a list of all potential side effects and/or adverse reactions for each medication listed above.</span>
                    <textarea id='txtsideeffects' name='txtsideeffects' className='add-only'></textarea>

                    <span className='eleHeader'>Please give a rationale/explanation of why the proposed medication is necessary to improve the child's psychiatric symptoms.</span>
                    <textarea id='txtrationale' name='txtrationale' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Lab studies, Blood Work, per protocol or other follow up needed</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'><input type='radio' id='rbneeded_Yes' name='rbneeded' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-150'><input type='radio' id='rbneeded_No' name='rbneeded' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_1' name='cbfollowupneeded_1' className='add-only' value='Lithium' /> Lithium </td>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_2' name='cbfollowupneeded_2' className='add-only' value='EKG' /> EKG </td>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_3' name='cbfollowupneeded_3' className='add-only' value='VPA' /> VPA </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_4' name='cbfollowupneeded_4' className='add-only' value='EEG' /> EEG </td>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_5' name='cbfollowupneeded_5' className='add-only' value='Tegretol' /> Tegretol </td>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_6' name='cbfollowupneeded_6' className='add-only' value='CT/MRI' /> CT/MRI </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbfollowupneeded_7' name='cbfollowupneeded_7' className='add-only' value='Other' /> Other </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_2' name='txtOther_2' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Explain as needed:</span>
                    <textarea id='txtExplainasneeded' name='txtExplainasneeded' className='add-only'></textarea>

                    <span className='eleHeader'>Please explain how the medications listed above interact with other medications the child takes:</span>
                    <textarea id='txtchildtakes' name='txtchildtakes' className='add-only'></textarea>

                    <span className='eleHeader'>Please explain what alternate treatment options are available:</span>
                    <textarea id='txtsideeffects' name='txtsideeffects' className='add-only'></textarea>

                    <span className='eleHeader'>Please explain what additional treatment will be used, i.e. individual counseling, group therapy, etc.</span>
                    <textarea id='txtadditionaltreatment' name='txtadditionaltreatment' className='add-only'></textarea>
                </p>

                <p className='w-750'> <b> <center>By signing below, I certify that the above information is true to the best of my knowledge.</center> </b></p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature Of Physician</td>
                        <td className='small w-375'> Date (Month, Day, Year)</td>
                    </tr>
                    <br />
                </table>

                <p className='w-750'> <b><center>PART B- To be completed by the DFCS local director or designee (CHECK ALL THAT APPLY)</center></b> </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbsigning_1' name='cbsigning_1' className='add-only' value='signing' /> By signing below, I give my consent for <input type='text' placeholder='Name of Child' id='txtmyconsent_1' name='txtmyconsent_1' className='add-only w-300 custom-add-only' /> to take the medication(s) listed above as prescribed by his/her physician.

                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbsigning_2' name='cbsigning_2' className='add-only' value='signing' /> By signing below, I <b><u>do not</u></b> give my consent for <input type='text' placeholder='Name of Child' id='txtmyconsent_2' name='txtmyconsent_2' className='add-only w-300 custom-add-only' /> to take the medication(s) listed above as prescribed by his/her physician.

                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Reason consent not given at this time</span>

                    <textarea id='txtReasonconsent' name='txtReasonconsent' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature of local DFCS County Director/Designee</td>
                        <td className='small w-375'> Date (Month, Day, Year)</td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>County</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DFCS Region</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Contact Number</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtCounty' name='txtCounty' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDFCSRegion' name='txtDFCSRegion' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtContactNumber' name='txtContactNumber' className='add-only' /> </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}